const attributeName = 'ยอมรับนโยบายคืนสินค้า/คืนเงิน';
// Shared across the page and drawer, including replacements during an in-flight save.
const consent = { initialized: false, checked: false, saved: false, pending: false, message: '' };
let nextId = 0;

function localTimestamp() {
  const date = new Date();
  const offset = -date.getTimezoneOffset();
  const local = new Date(date.getTime() + offset * 60000).toISOString().slice(0, -1);
  const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
  return `${local}${offset >= 0 ? '+' : '-'}${hours}:${minutes}`;
}

function renderAll() {
  document.querySelectorAll('refund-consent').forEach((element) => element.render());
}

class RefundConsent extends HTMLElement {
  #messageId = `refund-consent-message-${++nextId}`;
  #observer = new MutationObserver(() => this.render());

  connectedCallback() {
    if (!consent.initialized) {
      consent.checked = consent.saved = this.dataset.saved === 'true';
      consent.initialized = true;
    }
    this.addEventListener('change', this.#change);
    this.addEventListener('click', this.#click);
    // Horizon can morph children/attributes without reconnecting this custom element.
    this.#observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'disabled', 'data-empty', 'data-saved', 'aria-describedby', 'id'],
    });
    this.render();
  }

  disconnectedCallback() {
    this.#observer.disconnect();
    this.removeEventListener('change', this.#change);
    this.removeEventListener('click', this.#click);
  }

  get allowed() {
    return consent.saved && consent.checked && !consent.pending && this.dataset.empty !== 'true';
  }

  render() {
    const checkbox = this.querySelector('[data-refund-consent]');
    const button = this.querySelector('[name="checkout"]');
    const message = this.querySelector('[data-refund-consent-message]');
    if (!checkbox || !button || !message) return;
    checkbox.checked = consent.checked;
    // Keep the checkbox focusable while #change guards an in-flight save.
    checkbox.setAttribute('aria-disabled', String(consent.pending));
    const empty = this.dataset.empty === 'true';
    const blocked = !consent.saved || !consent.checked || consent.pending;
    if (button.disabled !== empty) button.disabled = empty;
    button.setAttribute('aria-disabled', String(empty || blocked));
    button.classList.toggle('is-consent-blocked', blocked);
    if (message.id !== this.#messageId) message.id = this.#messageId;
    if (checkbox.getAttribute('aria-describedby') !== this.#messageId) {
      checkbox.setAttribute('aria-describedby', this.#messageId);
    }
    this.setAttribute('aria-busy', String(consent.pending));
    const text = consent.message === 'error' ? this.dataset.errorMessage : this.dataset.requiredMessage;
    if (message.textContent !== text) message.textContent = text;
    message.hidden = !consent.message;
  }

  warn() {
    if (consent.message !== 'error') consent.message = 'required';
    renderAll();
  }

  #click = (event) => {
    // Interactive links inside labels keep their native navigation and never toggle the input.
    if (event.target.closest('a')) event.stopPropagation();
    if (event.target.closest('[data-refund-consent-checkout]') && !this.allowed) {
      event.preventDefault();
      this.warn();
      this.querySelector('[data-refund-consent]')?.focus();
    }
  };

  #change = async (event) => {
    if (!event.target.matches('[data-refund-consent]')) return;
    if (consent.pending) {
      this.render();
      return;
    }
    const checked = event.target.checked;
    const value = checked ? `ยอมรับแล้ว ${localTimestamp()}` : '';
    consent.checked = checked;
    consent.saved = false;
    consent.pending = true;
    consent.message = '';
    renderAll();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { [attributeName]: value } }),
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (cart.errors || (cart.attributes?.[attributeName] || '') !== value) {
        throw new Error('Consent was not saved');
      }
      consent.saved = checked;
    } catch {
      consent.checked = false;
      consent.saved = false;
      consent.message = 'error';
    } finally {
      consent.pending = false;
      renderAll();
    }
  };
}

if (!customElements.get('refund-consent')) customElements.define('refund-consent', RefundConsent);

function guardCart(event) {
  const target = event.target;
  const form = target instanceof HTMLFormElement ? target : target.form;
  if (!form || form.id !== 'cart-form') return;
  const controls = [...document.querySelectorAll('refund-consent')];
  if (controls.length && controls.every((control) => control.allowed)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  controls.forEach((control) => control.warn());
}

// Capture submit independently of button.disabled (requestSubmit and implicit form submission).
document.addEventListener('submit', guardCart, true);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || event.isComposing) return;
  // Preserve multiline notes and normal checkbox/link/button keyboard interactions.
  if (!(event.target instanceof HTMLInputElement) || event.target.type === 'checkbox') return;
  guardCart(event);
}, true);
